import React from 'react'
import styles from './styles.module.scss'

function simpleMessage({touched, error, warning}) {
  return (
    <div>
      {touched && (error && <span className={styles.error}>{error}</span> || warning && <span>{warning}</span>)}
    </div>
  )
}

export {simpleMessage}
